import React from 'react';
import { Check } from 'lucide-react';
export function PricingSection() {
  return <section id="oferta" className="py-4 sm:py-16 bg-[#0a1628] relative" data-id="element-177">
      <div className="max-w-4xl mx-auto px-3 sm:px-6" data-id="element-178">
        <div className="text-center mb-3 sm:mb-10" data-id="element-179">
          <h2 className="text-lg sm:text-4xl md:text-5xl font-black text-white uppercase tracking-tight" data-id="element-180">
            Oferta Especial
          </h2>
          <div className="h-1 w-16 sm:w-20 bg-[#fbbf24] mx-auto mt-2 rounded-full" data-id="element-181"></div>
        </div>

        {/* MAIN OFFER BOX */}
        <div className="bg-white rounded-xl shadow-2xl overflow-hidden border-3 border-[#fbbf24] mb-6 sm:mb-14" data-id="element-182">
          <div className="bg-gradient-to-r from-[#fbbf24] to-[#f59e0b] py-1.5 sm:py-4 text-center" data-id="element-183">
            <span className="text-[#0a1628] font-black text-xs sm:text-xl tracking-wider uppercase" data-id="element-184">
              ⭐ EL KIT MÁS VENDIDO ⭐
            </span>
          </div>

          <div className="p-2.5 sm:p-10 text-center" data-id="element-185">
            <h3 className="text-base sm:text-3xl font-bold text-gray-900 mb-2 sm:mb-6" data-id="element-186">
              Kit Completo Proyecto Organizacional Lista
            </h3>

            <div className="bg-gray-50 rounded-lg p-2.5 sm:p-6 mb-3 text-left max-w-md mx-auto border border-gray-200" data-id="element-187">
              <p className="font-bold text-gray-700 mb-1.5 uppercase text-[9px] sm:text-xs tracking-wide text-center" data-id="element-188">
                Incluye:
              </p>
              <ul className="space-y-1" data-id="element-189">
                {['Sistema completo (Módulos I a VI)', 'BONUS: Banco Profesional de Proyectos Organizacionales', 'BONUS: Planificación Anual Lista', 'Entrega digital en PDF vía Drive', 'Garantía de 7 días'].map((item, i) => <li key={i} className="flex items-center text-gray-800 font-medium text-[11px] sm:text-sm" data-id="element-190">
                    <Check className="h-3.5 w-3.5 sm:h-4 sm:w-4 text-green-500 mr-1.5 flex-shrink-0" strokeWidth={3} data-id="element-191" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-2" data-id="element-192">
              <span className="text-gray-400 text-sm sm:text-2xl line-through font-medium mb-0" data-id="element-193">
                $39.990
              </span>
              <div className="relative flex items-center justify-center" data-id="element-194">
                <div className="absolute inset-0 bg-[#16a34a]/20 blur-2xl rounded-full" data-id="element-195"></div>
                <span className="relative text-[#16a34a] text-3xl sm:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(21,128,61,0.5)] animate-pulse-subtle" data-id="element-196">
                  $19.990
                </span>
              </div>
              <span className="text-[#16a34a] text-xs sm:text-lg font-bold tracking-widest uppercase mt-0" data-id="element-197">
                ARS
              </span>
            </div>

            <a href="https://mi-tienda-2-8952.myshopify.com/cart/51602555437376:1" className="block w-full bg-[#16a34a] hover:bg-green-700 text-white text-sm sm:text-2xl font-black py-2.5 px-4 rounded-xl shadow-[0_4px_0_rgb(21,128,61)] hover:shadow-[0_2px_0_rgb(21,128,61)] hover:translate-y-[2px] transition-all uppercase mb-2" data-id="element-198">
              COMPRAR AHORA →
            </a>

            <p className="text-[10px] sm:text-base text-gray-600 mb-1.5 font-bold" data-id="element-199">
              MERCADO PAGO · TRANSFERENCIA POR WHATSAPP · DÉBITO · CRÉDITO
            </p>

            <p className="text-gray-500 text-[10px] sm:text-sm" data-id="element-200">
              Luego del pago, recibirás el acceso automáticamente en tu correo
              electrónico.
            </p>
          </div>
        </div>

        {/* UPSELL BOX */}
        <div className="bg-[#1e293b] rounded-xl shadow-2xl overflow-hidden border-2 border-gray-700 relative" data-id="element-201">
          <div className="w-full text-center bg-[#dc2626] py-1.5" data-id="element-202">
            <span className="text-white text-xs sm:text-lg font-black uppercase tracking-widest" data-id="element-203">
              Oferta Limitada
            </span>
          </div>

          <div className="p-2.5 sm:p-8" data-id="element-204">
            <div className="text-center mb-3" data-id="element-205">
              <span className="inline-block bg-blue-600 text-white text-[10px] sm:text-lg font-bold px-3 py-0.5 rounded-full mb-2 uppercase tracking-wide shadow-md" data-id="element-206">
                Pack Profesional
              </span>
              <h3 className="text-sm sm:text-2xl font-bold text-white mb-1" data-id="element-207">
                KIT COMPLETO + SISTEMA PRO DE GESTIÓN DE PROYECTOS
                ORGANIZACIONALES
              </h3>
              <p className="text-gray-400 text-[10px] sm:text-base" data-id="element-208">
                Llevá tus clases al siguiente nivel y trabajá proyectos
                organizacionales con un enfoque más profesional.
              </p>
            </div>

            {/* Upsell Image */}
            <div className="mb-3" data-id="element-209">
              <a href="https://mi-tienda-2-8952.myshopify.com/cart/51602556223808:1" className="block hover:opacity-90 transition-opacity" data-id="element-210">
                <img src="https://cdn.magicpatterns.com/uploads/pHSi4kTa7FtG2TPYveQPKt/upsell.png" alt="Sistema Pro de Gestión de Proyectos Organizacionales" className="w-full max-w-[200px] sm:max-w-md mx-auto h-auto rounded-lg sm:rounded-xl shadow-xl" data-id="element-211" />
              </a>
            </div>

            <div className="bg-[#0f172a] rounded-lg p-2.5 sm:p-6 mb-3 text-left max-w-lg mx-auto border border-gray-700" data-id="element-212">
              <p className="font-bold text-gray-300 mb-1.5 uppercase text-[9px] sm:text-xs tracking-wide text-center" data-id="element-213">
                Incluye:
              </p>
              <ul className="grid grid-cols-2 gap-1 sm:gap-1.5" data-id="element-214">
                {['Manual avanzado de análisis organizacional', 'Modelos profesionales de planificación de proyectos', 'Sistema de evaluación profesional para proyectos', 'Guía paso a paso de diagnóstico organizacional', 'Plantillas profesionales para análisis de proyectos', 'Banco ampliado de casos organizacionales', 'Proyecto modelo completamente resuelto', 'Manual de corrección profesional para docentes'].map((item, i) => <li key={i} className="flex items-start text-gray-300 text-[9px] sm:text-sm" data-id="element-215">
                    <Check className="h-3 w-3 sm:h-4 sm:w-4 text-[#fbbf24] mr-1 flex-shrink-0 mt-0.5" strokeWidth={3} data-id="element-216" />
                    {item}
                  </li>)}
              </ul>
            </div>

            <div className="flex flex-col items-center justify-center mb-2" data-id="element-217">
              <span className="text-gray-500 text-sm sm:text-lg line-through" data-id="element-218">
                $49.990
              </span>
              <div className="relative flex items-center justify-center" data-id="element-219">
                <div className="absolute inset-0 bg-[#fbbf24]/20 blur-2xl rounded-full" data-id="element-220"></div>
                <span className="relative text-[#fbbf24] text-3xl sm:text-7xl font-black tracking-tight drop-shadow-[0_0_20px_rgba(251,191,36,0.5)] animate-pulse-subtle" data-id="element-221">
                  $25.990
                </span>
              </div>
              <span className="text-[#fbbf24] text-xs sm:text-lg font-bold tracking-widest uppercase mt-0" data-id="element-222">
                ARS
              </span>
            </div>

            <a href="https://mi-tienda-2-8952.myshopify.com/cart/51602556223808:1" className="block w-full max-w-md mx-auto bg-[#16a34a] hover:bg-green-700 text-white text-xs sm:text-xl font-bold py-2 sm:py-4 px-4 rounded-xl shadow-lg transition-colors text-center mb-2" data-id="element-223">
              SÍ, QUIERO EL SISTEMA PRO →
            </a>

            <p className="text-[10px] sm:text-sm text-gray-400 text-center font-bold" data-id="element-224">
              MERCADO PAGO · TRANSFERENCIA POR WHATSAPP · DÉBITO · CRÉDITO
            </p>
          </div>
        </div>
      </div>
    </section>;
}